import styled from 'styled-components';

export const HealthBoxInfo = styled.div`
  justify-content: space-between;
  margin-top: 40px;
  display: flex;
`;

export const HealthExportContainer = styled.div`
  justify-content: flex-end;
  margin: 20px 0;
  display: flex;
`;

export const HealthTableContainer = styled.div`
  display: flex;
  margin-bottom: 50px;
`;
